import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@material-ui/core'
import { getQuestionWorkshop } from '../../../../services/Elegibilidad/get'
import {
  updateTestAnswerWorkshop,
  updateTestStatus,
  updateWorkShopStatus,
} from '../../../../services/Elegibilidad/put'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import swal from 'sweetalert'
import Swal from 'sweetalert2'
import { useHistory, useLocation } from 'react-router-dom'
import { createTestWorkshop } from '../../../../services/Elegibilidad/create'

export const QuestionsWorkshop = () => {
  const history = useHistory()
  const location = useLocation()
  const { idTest, codWorkshop } = location.state
  const [loading, setLoading] = useState(false)
  const [questions, setQuestions] = useState([])
  const [questionsAnswer, setQuestionsAnswer] = useState([])
  const [answer, setAnswer] = useState([])
  const [repeatWorkshop, setRepeatWorkshop] = useState(true)

  let contador = 0

  // Función para obtener las preguntas del Workshop
  const getQuestions = async (idTest) => {
    setLoading(true)

    try {
      const response = await getQuestionWorkshop(idTest)

      if (response.Success) {
        setQuestions(response.Data.WorkShopTest[0].WorkShopQuestions)
        setLoading(false)
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  // Funcion para crear el nuevo test
  const createTest = async () => {
    setLoading(true)
    formik.resetForm()
    setQuestionsAnswer([])

    try {
      const response = await createTestWorkshop(codWorkshop)

      if (response.Success) {
        setRepeatWorkshop(false)
        getQuestions(response.Data)
      } else {
        setLoading(false)
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    getQuestions(idTest)
  }, [])

  const EnviromentalPlanSchema = Yup.object().shape({
    question1: Yup.number().nullable().required('Este campo es obligatorio'),
    question2: Yup.number().nullable().required('Este campo es obligatorio'),
    question3: Yup.number().nullable().required('Este campo es obligatorio'),
    question4: Yup.number().nullable().required('Este campo es obligatorio'),
    question5: Yup.number().nullable().required('Este campo es obligatorio'),
  })

  const formik = useFormik({
    initialValues: {
      question1: null,
      question2: null,
      question3: null,
      question4: null,
      question5: null,
    },
    validationSchema: EnviromentalPlanSchema,
    onSubmit: (values) => {
      SaveWorkshop(values)
    },
  })

  const handleQuestion = (item, e, num) => {
    formik.setFieldValue(`question${1 + num}`, Number(e.target.value))
    if (item.CorrectAnswer === Number(e.target.value)) {
      // console.log('respuesta correcta')

      const result = questionsAnswer.filter((obj) => obj.question === 1 + num)

      if (result.length > 0) {
        const newState = questionsAnswer.map((obj) => {
          if (obj.question === 1 + num) {
            return { ...obj, correct: true }
          }

          return obj
        })

        setQuestionsAnswer(newState)
      } else {
        setQuestionsAnswer([
          ...questionsAnswer,
          {
            question: 1 + num,
            correct: true,
          },
        ])
      }
    } else {
      // console.log('respuesta incorrecta')
      const result = questionsAnswer.filter((obj) => obj.question === 1 + num)

      if (result.length > 0) {
        const newState = questionsAnswer.map((obj) => {
          if (obj.question === 1 + num) {
            return { ...obj, correct: false }
          }
          return obj
        })
        setQuestionsAnswer(newState)
      } else {
        setQuestionsAnswer([
          ...questionsAnswer,
          {
            question: 1 + num,
            correct: false,
          },
        ])
      }
    }

    setAnswer([
      ...answer,
      {
        IdTestAnswer: item.IdTestAnswer,
        AnswerReponse: Number(e.target.value),
      },
    ])
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('error', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Debe contestar todas las preguntas',
      icon: 'warning',
      button: 'Entendido',
    })
  }

  const SaveWorkshop = async () => {
    const result = questionsAnswer.filter((obj) => obj.correct === false)

    // Actualizando el estado del test
    let IdWorkshopStatus

    if (result.length >= 3) {
      IdWorkshopStatus = 3

      if (repeatWorkshop) {
        Swal.fire({
          title: `<h4>Ha reprobado el Taller Inicial
respondiendo ${5 - result.length}/5 de las preguntas
          planteadas.

         Se le recuerda que al seleccionar "No", no podrá repetir el cuestionario que acaba de realizar; en ese caso, sería necesario que solicite nuevamente un código a comunicacionescambio@bcie.org .
         
         ¿Desea repetir la prueba?</h4>`,
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.isConfirmed) {
            createTest()
          } else {
            updateWorkshop(IdWorkshopStatus)
            history.push('/')
          }
        })
      } else {
        updateWorkshop(IdWorkshopStatus)
        Swal.fire({
          title: `<h4>Ha reprobado el Taller Inicial
        respondiendo ${5 - result.length}/5 de las preguntas
        planteadas.
        
        Para repetir la prueba solicite un nuevo código a comunicacionescambio@bcie.org <h4>`,
          icon: 'error',
          // text: ' un nuevo código',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#3085d6',
        }).then((result) => {
          if (result.isConfirmed) {
            history.push('/')
          }
        })
      }
    } else {
      IdWorkshopStatus = 2
      updateWorkshop(IdWorkshopStatus)
      swal({
        title: '¡Felicidades ha aprobado el Taller Inicial!',
        text: 'Puede proceder a ingresar Formularios de Elegibilidad.',
        icon: 'success',
        button: 'Entendido',
      })
      history.push('/')
    }

    updateTest(IdWorkshopStatus, 5 - result.length)

    const body = {
      WorkShopAnwersRequest: answer,
    }

    try {
      const response = await updateTestAnswerWorkshop(body)
      if (response.Success) {
        console.log('datos guardados')
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  // Funcion para actualizar el status del test
  const updateTest = async (IdWorkshopStatus, ApprovedQuestions) => {
    const body = {
      IdTest: idTest,
      IdWorkshopStatus: IdWorkshopStatus,
      ApprovedQuestions: ApprovedQuestions,
    }
    try {
      const response = await updateTestStatus(body)

      if (response.Success) {
        console.log('datos guardaddos coreectamente')
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  // Funcion para actualizar el status del Workshop
  const updateWorkshop = async (IdWorkshopStatus) => {
    const body = {
      CodWorkshop: codWorkshop,
      IdWorkshopStatus: IdWorkshopStatus,
    }
    try {
      const response = await updateWorkShopStatus(body)

      if (response.Success) {
        console.log('Workshop actualizado correactemente')
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  return (
    <>
      {loading ? (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      ) : (
        <div
          id="wizard-form"
          style={{
            overflow: 'hidden',
            backgroundColor: 'white',
            boxShadow: '0px 0px 12px -2px rgba(0,0,0,0.39)',
          }}
        >
          <div style={{ marginBottom: '48px' }}>
            <Grid item md={12} sm={12} xs={12}>
              <div
                style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '8px',
                }}
              >
                <label className="formTitle">Taller Inicial</label>
              </div>
              <label className="formDescription">
                Seleccione las respuestas que completen el Taller Inicial. No
                salir del cuestionario hasta finalizarlo, ya que requerirá de un
                código para volverlo a tomar.
              </label>
            </Grid>

            {questions.length > 0 ? (
              questions.map((item, key) => {
                contador += 1
                return (
                  <Grid
                    container
                    spacing={1}
                    className="input__container"
                    key={key}
                  >
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        {contador}. {item.Descripcion}
                      </label>
                    </Grid>

                    {item.QuestionType === '1' && (
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl style={{ width: '100%' }}>
                          <RadioGroup
                            id="IsNativeCommunity"
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            onChange={(e) => handleQuestion(item, e, key)}
                          >
                            {item.AnswerList.map((itemAnswer, key) => (
                              <FormControlLabel
                                value={itemAnswer.idOrden.toString()}
                                key={itemAnswer.idOrden}
                                control={<Radio />}
                                label={itemAnswer.Answer}
                              />
                            ))}
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    )}
                    {item.QuestionType === '2' && (
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl style={{ width: '100%' }}>
                          <RadioGroup
                            id="IsNativeCommunity"
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            onChange={(e) => handleQuestion(item, e, key)}
                          >
                            <FormControlLabel
                              value="1"
                              control={<Radio />}
                              label="Si"
                            />
                            <FormControlLabel
                              value="2"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    )}
                  </Grid>
                )
              })
            ) : (
              <></>
            )}
            <Grid className="buttonsPYME">
              <Button
                className="confirmButton"
                type="button"
                onClick={validateFormStatus}
              >
                Presentar
              </Button>
            </Grid>
          </div>
        </div>
      )}
    </>
  )
}
